import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";

import { title } from "utils";

import { Header, ProjectLog } from "components";

class LogsListPage extends Component {
  render() {
    const bread = [{ text: "Journal de chantier" }];

    return (
      <Fragment>
        <Helmet>{title("Journal de chantier")}</Helmet>

        <Header title="Journal de chantier" bread={bread} />

        <div className="logs-list-page main-content">
          <div className="log-wrap">
            <ProjectLog />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default LogsListPage;
